import { useState } from "react"
import { ChevronUp, ChevronDown } from "lucide-react"
export default function FilterSection({ title, children, defaultOpen = true }) {
    const [open, setOpen] = useState(defaultOpen)
    return (
        <div className="py-4 border-b border-gray-200 last:border-b-0">
            <div className="flex items-center justify-between w-full">
                <h3 className="text-base font-bold text-gray-900">{title}</h3>
                <button
                    type="button"
                    onClick={() => setOpen((o) => !o)}
                    aria-label={open ? `Collapse ${title}` : `Expand ${title}`}
                    aria-expanded={open}
                    className="p-1 -m-1"
                >
                    {open ? (
                        <ChevronUp className="w-4 h-4 text-gray-600" />
                    ) : (
                        <ChevronDown className="w-4 h-4 text-gray-600" />
                    )}
                </button>
            </div>

            {open && <div className="mt-3 space-y-2">{children}</div>}
        </div>
    )
}
